import { render, staticRenderFns } from "./agam_AppFooter.vue?vue&type=template&id=77509416&"
import script from "./agam_AppFooter.vue?vue&type=script&lang=js&"
export * from "./agam_AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./agam_AppFooter.vue?vue&type=style&index=0&id=77509416&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports